$(function() {
  // HEADER FIXED
  var $nav_diet = $('.js-nav-diet');

  $(window).on('scroll', function() {
    if ( $(window).scrollTop() >= 5 ) {
      $nav_diet.addClass('is-scroll');
    } else {
      $nav_diet.removeClass('is-scroll');
    }
  });

	// NAV ON MOBILES
	var $nav = $('.js-nav'),
		$overlay = $('.box-overlay'),
		$body = $('body'),
		$burger = $('.js-burger'),
    $navClose = $('.js-nav-close');


	$burger.on('click', function() {
		if ( !$(this).hasClass('is-active') ) {
			$(this).addClass('is-active');
			$nav.addClass('is-active');
			$overlay.fadeIn();
			$body.addClass('nav-is-active');
		} else {
			navHide();
		}
	});

	$overlay.on('click', navHide);
  $navClose.on('click', navHide);

	function navHide() {
		$burger.removeClass('is-active');
		$nav.removeClass('is-active');
		$overlay.fadeOut();
		$body.removeClass('nav-is-active');
	}


	// ANCHORS
	var $anchors = $('.js-anchor');

	$anchors.on('click', function(e) {
		e.preventDefault();

		var id = $(this).attr('href');

		$('html, body').animate({scrollTop:$(id).offset().top - 25 }, 800);
		navHide();
	});

  // MODALS
  $('.js-modal-target').on('click', function(e) {
    e.preventDefault();

    $('#course_id').val(this.dataset.course);
    createFormUrl(this.dataset.course);

    var modalTitle = $(this).attr('href');

    $(modalTitle).addClass('is-show');
    $body.addClass('scroll-disabled');
  });


  $('.js-modal-bg').on('click', modalHide);
  $('.js-modal-close').on('click', modalHide);

  function modalHide() {
    $('.modal-wrap').removeClass('is-show');
    $body.removeClass('scroll-disabled');
  }

  function createFormUrl(course_id) {
    $('#form-payment').attr('action', '/orders/checkout-course/' + course_id);
    $('#form-registration').attr('action', '/orders/registration-for-course/' + course_id);
  }

  // SOCIAL MEDIA FORM HANDLER
  $('#js-social-media-form').each(function(){
    $(this).validate({
      rules: {
        phone: {
          required: true,
          phone: true
        }
      },
      messages: {
        phone: {
          required: "Поле обов'язкове",
          phone: "Введіть коректний номер"
        }
      }
    });
  });
  $('.js-social-media-button').on('click', function (event) {
    if ($('#js-social-media-form').valid()) {
      event.preventDefault();
      $('#modal-thanks-social-input').val($(this).data('social'));
      $('#js-social-media-form').trigger('submit');
    }
  });

  // CHECK INPUT
  var inputs = $('.js-input');

  inputs.on('change', function(e) {
    if (!$(this).val()) {
      $(this).removeClass('is-change');
    } else {
      $(this).addClass('is-change');
    }
  });

  // FOCUS INPUT
  inputs.on('focus', function(e) {
    let input_name = e.target.name;
    let input_label_id = '#label-' + input_name;
    $(input_label_id).addClass('form__label-up');
  });

  inputs.on('focusout', function(e) {
    let input_name = e.target.name;
    let input_label_id = '#label-' + input_name;
    if (!$(this).val()) {
      $(input_label_id).removeClass('form__label-up');
    }
  });

  // FAQ
  var $faq = $('.collapse__header');

  $faq.on('click', function(e) {
    $(this).toggleClass('is-active');
    $(this).next().toggle(300);
  });


	// *********** PLUGINS *******************

	$('.js-reviews-carousel').slick({
		rows: 0,
		arrows: false,
		dots: true,
		slidesToShow: 3,
  		slidesToScroll: 3,
  		responsive: [
  			{
  				breakpoint: 1050,
  				settings: {
  					slidesToShow: 2,
  					slidesToScroll: 2,
  				}
  			},
  			{
  				breakpoint: 700,
  				settings: {
  					slidesToShow: 1,
  					slidesToScroll: 1,
  				}
  			}
  		]
	});

  //CAROUSELS
  $('.js-carousel').slick({
    rows: 0,
    arrows: false,
    dots: true
  });

  $('.js-phone-carousel').slick({
    rows: 0,
    arrows: false,
    autoplay: true,
    speed: 800,
    dots: true,
    appendDots: '.phone-dots',
  });


  var $carousel = $('.js-m-carousel');

  $carousel.slick({
    rows: 0,
    infinite: false,
    slidesToShow: 1,
    variableWidth: true,
    appendArrows: '.js-m-carousel-controls',
    prevArrow: '<button class="prev"><svg width="10" height="18"><use xlink:href="/img/landing/diet_2/sprite.svg#next"></use></svg></button>',
    nextArrow: '<button class="next"><svg width="10" height="18"><use xlink:href="/img/landing/diet_2/sprite.svg#next"></use></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          variableWidth: false
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          variableWidth: false
        }
      },

    ]
  });

  var $carousel_new_born = $('.js-nb-carousel');

  $carousel_new_born.slick({
    rows: 0,
    slidesToShow: 1,
    //centerMode: true,
    variableWidth: true,
    appendArrows: '.js-nb-carousel-controls',
    prevArrow: '<button class="arrow-prev" type="button"><img src="/img/landing/new_born/next.svg" width="44" height="44" alt="" loading="lazy"></button>',
    nextArrow: '<button class="arrow-next" type="button"><img src="/img/landing/new_born/next.svg" width="44" height="44" alt="" loading="lazy"></button>'
  });

	AOS.init({
        duration: 800,
        once: true,
        //easing: 'ease-out-back',
        disable: 'mobile'
    });

	// ******* TEL INPUT *******

  function getIpinfo(){
    return $.get("https://ipinfo.io?token=2f6c0e302d4989", function () {}, "jsonp");
  }

  function setCountry(country) {
    if (country !== ''){
      Cookies.set('country', country, {expires: 1});
    }
  }

  var country = Cookies.get('country');
  if(!country) {
    getIpinfo().always(function (resp) {
      country = (resp && resp.country) ? resp.country : "";
      setCountry(country);
    });
  }

  $('input[type="tel"]').intlTelInput({
    geoIpLookup: function(callback) {
      if(!country) {
        getIpinfo().always(function (resp) {
          country = (resp && resp.country) ? resp.country : "";
          setCountry(country);
          callback(country);
        });
      }
      else{
        callback(country);
      }
    },
    initialCountry: "ua",
    nationalMode: false,
    preferredCountries: ['ua'],
    // separateDialCode: true,
    utilsScript: "/js/intlTelInput/utils.js"
  });

  $.validator.methods.phone = function( value, element ) {
    return this.optional( element ) || $(element).intlTelInput("isValidNumber");
  };

  $('#form-early-bird').each(function(){
    $(this).validate({
      rules: {
        name: {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          phone: true
        }
      },
      messages: {
        name: {
          required: "Поле обов'язкове",
          minlength: "Мінімум 2 символи",
          maxlength: "Максимум 255 символів"
        },
        email: {
          required: "Поле обов'язкове",
          email: "Введіть коректний email"
        },
        phone: {
          required: "Поле обов'язкове",
          phone: "Введіть коректний номер"
        }
      }
    });
  });

  $('.form-current-page-registration').each(function(){
    $(this).validate({
      rules: {
        name: {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          phone: true
        }
      },
      messages: {
        name: {
          required: "Поле обов'язкове",
          minlength: "Мінімум 2 символи",
          maxlength: "Максимум 255 символів"
        },
        email: {
          required: "Поле обов'язкове",
          email: "Введіть коректний email"
        },
        phone: {
          required: "Поле обов'язкове",
          phone: "Введіть коректний номер"
        }
      }
    });
  });

  $('.form-current-page-registration').on('submit', function () {
    if ($(this).valid()) {
      fbq('track', 'Lead');
      if($(this).data('landing-name') === 'children') {
				gtag('event', 'conversion_event_submit_lead_form_4', {});
			}
    }
  })

  $('#form-registration').each(function(){
    $(this).validate({
      rules: {
        name: {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          phone: true
        }
      },
      messages: {
        name: {
          required: "Поле обов'язкове",
          minlength: "Мінімум 2 символи",
          maxlength: "Максимум 255 символів"
        },
        email: {
          required: "Поле обов'язкове",
          email: "Введіть коректний email"
        },
        phone: {
          required: "Поле обов'язкове",
          phone: "Введіть коректний номер"
        }
      }
    });
  });

  $('#form-payment').each(function(){
    $(this).validate({
      rules: {
        name: {
          required: true,
          minlength: 2,
          maxlength: 255
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true,
          phone: true
        }
      },
      messages: {
        name: {
          required: "Поле обов'язкове",
          minlength: "Мінімум 2 символи",
          maxlength: "Максимум 255 символів"
        },
        email: {
          required: "Поле обов'язкове",
          email: "Введіть коректний email"
        },
        phone: {
          required: "Поле обов'язкове",
          phone: "Введіть коректний номер"
        }
      }
    });
  });

  $('#form-early-bird').on('submit', function () {
    if ($('#form-early-bird').valid()) {
      fbq('track', 'Lead');
      gtag('event', 'conversion_event_submit_lead_form_2');
      gtag('event', 'conversion', {'send_to': 'AW-16469911291/XxaaCIvP5ZgZEPvNu609'});
      tiktokEvent(null, null);
    }
  })

  function tiktokEvent(email, phone) {
    if (email && phone) {
      hash(email).then(
        function (hash_email) {
          hash(phone).then(
            function (hash_phone) {
              ttq.identify({
                'email': hash_email,
                'phone_number': hash_phone
              });
            }
          );
        }
      );
    } else {
      ttq.identify({});
    }
  }

  async function hash(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
    });
  }

  // *********** FORM *******************

  function addUtmParams() {
    let utm_source = getParameterByName('utm_source');
    let utm_medium = getParameterByName('utm_medium');
    let utm_campaign = getParameterByName('utm_campaign');
    let utm_term = getParameterByName('utm_term');
    let utm_content = getParameterByName('utm_content');

    $('#utm_source').val(utm_source);
    $('#utm_medium').val(utm_medium);
    $('#utm_campaign').val(utm_campaign);
    $('#utm_term').val(utm_term);
    $('#utm_content').val(utm_content);

    appendUtmForPurchase(utm_source, utm_medium, utm_campaign, utm_term, utm_content);
  }

  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  function appendUtmForPurchase(utm_source, utm_medium, utm_campaign, utm_term, utm_content) {
    let separators = ['?', '&', '&', '&', '&'];
    let utm = '';

    utm += utm_source !== '' ? separators.shift() + 'utm_source=' + utm_source : '';
    utm += utm_medium !== '' ? separators.shift() + 'utm_medium=' + utm_medium : '';
    utm += utm_campaign !== '' ? separators.shift() + 'utm_campaign=' + utm_campaign : '';
    utm += utm_term !== '' ? separators.shift() + 'utm_term=' + utm_term : '';
    utm += utm_content !== '' ? separators.shift() + 'utm_content=' + utm_content : '';

    $(".go_to_payment_button").each(function() {
      let _href = $(this).attr("href");
      $(this).attr("href", _href + utm);
    });
  }

  addUtmParams();

  var referrer = getParameterByName('ref');
  var utm_source = getParameterByName('utm_source');
  var utm_medium = getParameterByName('utm_medium');
  var utm_campaign = getParameterByName('utm_campaign');
  var utm_term = getParameterByName('utm_term');
  var utm_content = getParameterByName('utm_content');

  if(referrer){
    Cookies.set('ref_hash', referrer, { expires: 7 });
  }

  if(utm_source){
    Cookies.set('utm_source', utm_source, { expires: 1 });
    if(utm_medium){
      Cookies.set('utm_medium', utm_medium, { expires: 1 });
    } else {
      Cookies.remove('utm_medium');
    }
    if(utm_campaign){
      Cookies.set('utm_campaign', utm_campaign, { expires: 1 });
    } else {
      Cookies.remove('utm_campaign');
    }
    if(utm_term){
      Cookies.set('utm_term', utm_term, { expires: 1 });
    } else {
      Cookies.remove('utm_term');
    }
    if(utm_content){
      Cookies.set('utm_content', utm_content, { expires: 1 });
    } else {
      Cookies.remove('utm_content');
    }
  }

  function updateCoursePrices(promocode, course_ids){

    $.ajax({
      type: 'post',
      url: '/landing/pages/ajax-get-discount-course-prices',
      data: {
        "course_ids": course_ids,
        "promocode": promocode
      },
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      },
      success: function (response) {
        if (response.course_prices && response.promocode) {
          $.each(response.course_prices, function(index, value) {
            $('#course_price_'+index).html(value);
            $('#form_promocode_'+index).val(response.promocode);
          });
        }
      },
      error: function(e) {
        console.log(e.responseText);
      }
    });
  }

  $('#promocode-button').on('click', function(){
    let promocode = $('#promocode-input').val().trim();
    let course_ids = [30,31,32]; /* diet courses ids */

    if(typeof(promocode) != "undefined" && promocode !== null && promocode.length) {
      updateCoursePrices(promocode, course_ids);
    }
  });

  /* TODO: Create it more useful. Add link into attr */
  //SHOW FIRST YEAR LANDING VIDEO
  $('.js-first-year-video').on('click', function(e) {
    $(this).html('<iframe class="media__v" src="https://player.vimeo.com/video/447744563" allowfullscreen></iframe>');
  });

  //SHOW DIET LANDING VIDEO
  $('.js-diet-video').on('click', function(e) {
    $(this).html('<iframe class="media__v" src="https://www.youtube.com/embed/h1F7AZ398ng?autoplay=1" allowfullscreen></iframe>');
  });

  //SHOW DIET LANDING VIDEO RESULTS
  $('.js-diet-video-result').on('click', function(e) {
    $(this).html('<iframe class="media__v" src="https://www.youtube.com/embed/K00dLoyZKYk?autoplay=1" allowfullscreen></iframe>');
  });

  //CAROUSEL
  $('.js-new-carousel').slick({
    rows: 2,
    slidesToShow: 2,
    slidesToScroll: 1,
    appendArrows: '.js-new-controls',
    nextArrow:'<button type="button" class="slick-next" aria-label="Next"><svg width="8" height="14"><use xlink:href="/img/landing/parenthood_overweight/sprite.svg#corner"></use></svg></button>',
    prevArrow:'<button type="button" class="slick-prev" aria-label="Prev"><svg width="8" height="14"><use xlink:href="/img/landing/parenthood_overweight/sprite.svg#corner"></use></svg></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          rows: 1,
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 601,
        settings: {
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  /* ---- vitamin page ----*/

  //CAROUSEL
  $('.js-carousel-vitamin').slick({
    rows: 0,
    arrows: false,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });

  //TABS
  var $title = $('.js-tabs .tabs__list-item');
  var $content = $('.js-tabs .tabs__body');

  $title.on('click', function() {
    var name = $(this).attr('data-tabs');

    $title.removeClass('is-active');
    $content.removeClass('is-active');

    $('[data-tabs=' + name + ']').addClass('is-active');
    $('#' + name).addClass('is-active');
  });

  //VIDEO CREATE
  document.querySelector('body').addEventListener('click', function(e) {
    let target = e.target.closest('[data-video]');

    if( !target ) return;

    let targetVideo = target.dataset.video;
    let parent = target.parentElement;

    parent.innerHTML = targetVideo;
  });

  // ACCORDION
  let headerAccordion = $('.accordion__header');

  headerAccordion.on('click', function() {
    $(this).parent().toggleClass('is-active');
    $(this).parent().find('.accordion__body').toggle(300);
  });

  // REVIEWS
  let maxHeightReviews = 1032;
  let reviews = $('.js-reviews');
  let btnToggle = $('.js-more');
  let btnParent = btnToggle.parents('.review-more');

  if( reviews.innerHeight() > 1160 ) {
    reviews.css('height', maxHeightReviews);
    reviews.addClass('is-cropped');
    btnParent.addClass('is-visible');
  }

  btnToggle.on('click', function() {
    if( reviews.hasClass('is-cropped') ) {
      reviews.height('auto').removeClass('is-cropped');
      btnParent.removeClass('overlay');
      $(this).html('Показати менше');
    } else {
      reviews.css('height', maxHeightReviews);
      reviews.addClass('is-cropped');
      btnParent.addClass('overlay');
      $(this).html('Показати більше');
      setTimeout(() => {
        $('html, body').animate({scrollTop: btnParent.offset().top - 20}, 500);
      }, 100);
    }
  });

  $(document).on('click', '.message-close', function(){
    var parent = $(this).parent('.message');
    parent.removeClass('slideInUp').addClass('slideOutDown');
    setTimeout(function(){
      parent.css('display', 'none');
    }, 300);
  });

});
